import { render, staticRenderFns } from "./sample-ribbon.vue?vue&type=template&id=ef925e42&"
import script from "./sample-ribbon.vue?vue&type=script&lang=ts&"
export * from "./sample-ribbon.vue?vue&type=script&lang=ts&"
import style0 from "./sample-ribbon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports